<template>
  <div class="menu-secundario" :class="{ 'menu-secundario--mobile': device.isMobile }">
    <div v-if="!device.isMobile" class="menu-secundario__desktop">
      <nav class="menu-sec-primary" :aria-label="$t('menuSecundario.ariaPrimary')">
        <ul class="menu-sec-primary__list">
          <li
            v-for="link in navPrimary"
            :key="link.catalogMenu ? 'nav-catalog' : link.to"
            class="menu-sec-primary__item"
            :class="{ 'menu-sec-primary__item--catalog': link.catalogMenu }"
          >
            <template v-if="!link.catalogMenu">
              <router-link
                :to="link.to"
                class="menu-sec-primary__link-inner"
                active-class="is-active"
                exact-active-class="is-exact-active"
              >
                <i :class="link.icon" class="menu-sec-primary__icon" aria-hidden="true" />
                <span class="menu-sec-primary__text">
                  <span class="menu-sec-primary__label">{{ link.label }}</span>
                  <span class="menu-sec-primary__hint">{{ link.hint }}</span>
                </span>
              </router-link>
            </template>
            <div
              v-else
              class="menu-sec-primary__catalog-wrap"
              :class="{ 'is-open': catalogPanelOpen }"
              @mouseenter="catalogPanelOpen = true"
              @mouseleave="onCatalogMouseLeave"
              @focusin="catalogPanelOpen = true"
              @focusout="onCatalogFocusOut"
            >
              <router-link
                :to="link.to"
                class="menu-sec-primary__link-inner menu-sec-primary__link-inner--catalog"
                active-class="is-active"
                :aria-expanded="catalogPanelOpen"
                aria-haspopup="true"
              >
                <i :class="link.icon" class="menu-sec-primary__icon" aria-hidden="true" />
                <span class="menu-sec-primary__text">
                  <span class="menu-sec-primary__label">{{ link.label }}</span>
                  <span class="menu-sec-primary__hint">{{ link.hint }}</span>
                </span>
                <i class="pi pi-angle-down menu-sec-primary__chevron" aria-hidden="true" />
              </router-link>
              <div
                class="menu-sec-primary__panel"
                role="region"
                :aria-label="$t('menuSecundario.panelCategoriesAria', { label: link.label })"
              >
                <p class="menu-sec-primary__panel-kicker">{{ $t('menuSecundario.panelKicker') }}</p>
                <div v-if="categoriasNavLoading" class="menu-sec-primary__panel-state">
                  <i class="pi pi-spinner pi-spin menu-sec-primary__panel-spinner" aria-hidden="true" />
                  {{ $t('menuSecundario.loadingCats') }}
                </div>
                <p v-else-if="categoriasNavError" class="menu-sec-primary__panel-state menu-sec-primary__panel-state--muted">
                  {{ $t('menuSecundario.catsError') }}
                </p>
                <div v-else-if="!categoriasNav.length" class="menu-sec-primary__panel-state menu-sec-primary__panel-state--muted">
                  {{ $t('menuSecundario.catsEmpty') }}
                </div>
                <div v-else class="menu-sec-primary__panel-grid">
                  <router-link
                    v-for="cat in categoriasNavPanel"
                    :key="'nav-cat-' + cat.id"
                    class="menu-sec-primary__panel-link"
                    :to="{ path: '/catalogo-productos', query: { categoria_id: cat.id } }"
                  >
                    <span class="menu-sec-primary__panel-link-text">{{ cat.nombre }}</span>
                    <i class="pi pi-arrow-right menu-sec-primary__panel-link-arrow" aria-hidden="true" />
                  </router-link>
                </div>
                <div class="menu-sec-primary__panel-footer">
                  <router-link to="/catalogo-productos" class="menu-sec-primary__panel-cta">
                    {{ $t('menuSecundario.seeFullCatalog') }}
                    <i class="pi pi-arrow-right menu-sec-primary__panel-cta-icon" aria-hidden="true" />
                  </router-link>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </nav>
    </div>

    <Sidebar
      v-model:visible="visibleRight"
      position="left"
      dismissable
      class="site-drawer-shell"
      :style="sidebarWidthStyle"
      @hide="onSidebarHide"
    >
      <div class="site-drawer">
        <header class="site-drawer__hero">
          <p class="site-drawer__eyebrow">{{ $t('menuSecundario.drawerEyebrow') }}</p>
          <p class="site-drawer__title">{{ shopLabel }}</p>
          <p class="site-drawer__subtitle">{{ $t('menuSecundario.drawerSubtitle') }}</p>
        </header>

        <nav class="site-drawer__nav" :aria-label="$t('menuSecundario.drawerNavAria')">
          <div v-for="block in drawerBlocks" :key="block.title" class="site-drawer__block">
            <p class="site-drawer__section">{{ block.title }}</p>
            <ul class="site-drawer__list">
              <li v-for="item in block.items" :key="item.label">
                <router-link
                  v-if="item.to"
                  :to="item.to"
                  class="site-drawer__link"
                  @click="closeDrawer"
                >
                  <i :class="item.icon" aria-hidden="true" />
                  <span class="site-drawer__link-text">
                    <span class="site-drawer__link-label">{{ item.label }}</span>
                    <span v-if="item.hint" class="site-drawer__link-hint">{{ item.hint }}</span>
                  </span>
                </router-link>
                <button
                  v-else-if="item.action === 'login'"
                  type="button"
                  class="site-drawer__link site-drawer__link--btn"
                  @click="goLogin"
                >
                  <i class="pi pi-sign-in" aria-hidden="true" />
                  <span class="site-drawer__link-text">
                    <span class="site-drawer__link-label">{{ item.label }}</span>
                    <span v-if="item.hint" class="site-drawer__link-hint">{{ item.hint }}</span>
                  </span>
                </button>
                <button
                  v-else-if="item.action === 'perfil'"
                  type="button"
                  class="site-drawer__link site-drawer__link--btn"
                  @click="goPerfil"
                >
                  <i class="pi pi-id-card" aria-hidden="true" />
                  <span class="site-drawer__link-text">
                    <span class="site-drawer__link-label">{{ item.label }}</span>
                    <span v-if="item.hint" class="site-drawer__link-hint">{{ item.hint }}</span>
                  </span>
                </button>
              </li>
            </ul>
          </div>
        </nav>

        <div class="site-drawer__logo">
          <LogoComponente :device="device" />
        </div>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import LogoComponente from '@/components/LogoComponent';
import Sidebar from 'primevue/sidebar';
import CategoriaService from '@/services/CategoriaService';
import { sessionStore } from '@/store/session';

export default {
  name: 'MenuSecundario',
  components: { LogoComponente, Sidebar },
  props: {
    device: {
      type: Object,
      required: true,
    },
    externalOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close-site-menu'],
  data() {
    return {
      visibleRight: false,
      catalogPanelOpen: false,
      categoriasNav: [],
      categoriasNavLoading: false,
      categoriasNavError: false,
    };
  },
  mounted() {
    this.loadCategoriasNav();
  },
  computed: {
    navPrimary() {
      const L = (k) => this.$t(`menuSecundario.nav.${k}.label`);
      const H = (k) => this.$t(`menuSecundario.nav.${k}.hint`);
      return [
        { label: L('nosotros'), hint: H('nosotros'), to: '/nosotros', icon: 'pi pi-users' },
        {
          label: L('catalogo'),
          hint: H('catalogo'),
          to: '/catalogo-productos',
          icon: 'pi pi-th-large',
          catalogMenu: true,
        },
        { label: L('historias'), hint: H('historias'), to: '/historia-destacados', icon: 'pi pi-images' },
        { label: L('contacto'), hint: H('contacto'), to: '/contacto', icon: 'pi pi-envelope' },
        { label: L('trabaja'), hint: H('trabaja'), to: '/trabaja-con-nosotros', icon: 'pi pi-briefcase' },
      ];
    },
    shopLabel() {
      return (process.env.VUE_APP_SHOP_NAME || 'KOSEXA').trim();
    },
    sidebarWidthStyle() {
      return {
        width: this.device.isMobile ? 'min(400px, 92vw)' : 'min(340px, 42vw)',
      };
    },
    categoriasNavPanel() {
      const list = Array.isArray(this.categoriasNav) ? this.categoriasNav : [];
      return list.slice(0, 12);
    },
    drawerBlocks() {
      const s = sessionStore();
      const authed = !!(s.access_token || (typeof localStorage !== 'undefined' && localStorage.getItem('access_token')));
      const d = (k) => ({
        label: this.$t(`menuSecundario.drawer.${k}.label`),
        hint: this.$t(`menuSecundario.drawer.${k}.hint`),
      });
      const explore = {
        title: this.$t('menuSecundario.blockExplore'),
        items: [
          { ...d('inicio'), to: '/', icon: 'pi pi-home' },
          { ...d('catalogo'), to: '/catalogo-productos', icon: 'pi pi-th-large' },
          { ...d('historias'), to: '/historia-destacados', icon: 'pi pi-images' },
          { ...d('nosotros'), to: '/nosotros', icon: 'pi pi-users' },
          { ...d('contacto'), to: '/contacto', icon: 'pi pi-envelope' },
          { ...d('trabaja'), to: '/trabaja-con-nosotros', icon: 'pi pi-briefcase' },
          { ...d('carrito'), to: '/validar-carrito', icon: 'pi pi-shopping-cart' },
        ],
      };
      const cuentaItems = authed
        ? [{ ...d('perfil'), action: 'perfil', icon: 'pi pi-id-card' }]
        : [
            { ...d('login'), action: 'login', icon: 'pi pi-sign-in' },
            { ...d('registro'), to: '/registro', icon: 'pi pi-user-plus' },
          ];
      return [
        explore,
        { title: this.$t('menuSecundario.blockAccount'), items: cuentaItems },
      ];
    },
  },
  watch: {
    externalOpen(val) {
      if (val) {
        this.visibleRight = true;
      }
    },
    visibleRight(val) {
      if (!val) {
        this.$emit('close-site-menu');
      }
    },
  },
  methods: {
    loadCategoriasNav() {
      this.categoriasNavLoading = true;
      this.categoriasNavError = false;
      CategoriaService.getCategorias()
        .then((res) => {
          this.categoriasNav = Array.isArray(res.data) ? res.data : [];
        })
        .catch(() => {
          this.categoriasNav = [];
          this.categoriasNavError = true;
        })
        .finally(() => {
          this.categoriasNavLoading = false;
        });
    },
    onCatalogMouseLeave() {
      this.catalogPanelOpen = false;
    },
    onCatalogFocusOut(e) {
      const wrap = e.currentTarget;
      if (wrap && e.relatedTarget && wrap.contains(e.relatedTarget)) return;
      this.catalogPanelOpen = false;
    },
    onSidebarHide() {
      this.$emit('close-site-menu');
    },
    closeDrawer() {
      this.visibleRight = false;
      this.$emit('close-site-menu');
    },
    goLogin() {
      this.$router.push('/login');
      this.closeDrawer();
    },
    goPerfil() {
      this.$router.push('/perfil-usuario');
      this.closeDrawer();
    },
  },
};
</script>

<style scoped>
.site-drawer {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 0.25rem 0.5rem 1.25rem;
  box-sizing: border-box;
}

.site-drawer__hero {
  padding: 0.5rem 0.75rem 1.25rem;
  margin-bottom: 0.25rem;
  border-bottom: 1px solid rgba(201, 169, 98, 0.18);
}

.site-drawer__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.5625rem;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: rgba(201, 169, 98, 0.75);
}

.site-drawer__title {
  margin: 0 0 0.35rem;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 1.35rem;
  font-weight: 400;
  letter-spacing: 0.08em;
  color: var(--text-color);
}

.site-drawer__subtitle {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.45;
  color: var(--text-secondary);
  font-weight: 300;
}

.site-drawer__block {
  margin-bottom: 1.15rem;
}

.site-drawer__section {
  margin: 0 0 0.4rem 0.75rem;
  font-size: 0.6rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--text-muted-600);
}

.site-drawer__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.site-drawer__list li {
  margin: 0;
}

.site-drawer__link {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  width: 100%;
  padding: 0.62rem 0.75rem;
  margin: 0.12rem 0;
  border-radius: 10px;
  text-decoration: none;
  color: var(--text-color) !important;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  border: 1px solid transparent;
  background: var(--menu-panel-link-bg);
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
  box-sizing: border-box;
  text-align: left;
  cursor: pointer;
}

.site-drawer__link i {
  font-size: var(--nav-icon-font-size, 1.125rem);
  color: #c9a962;
  width: 1.25rem;
  flex-shrink: 0;
  text-align: center;
}

.site-drawer__link-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.1rem;
  min-width: 0;
}

.site-drawer__link-label {
  line-height: 1.25;
}

.site-drawer__link-hint {
  font-size: 0.7rem;
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: 1.3;
  color: var(--text-secondary);
}

.site-drawer__link:hover {
  background: rgba(201, 169, 98, 0.1);
  border-color: rgba(201, 169, 98, 0.22);
  color: var(--menu-panel-link-hover-text) !important;
}

.site-drawer__link--btn {
  font: inherit;
  appearance: none;
}

.site-drawer__logo {
  margin-top: auto;
  padding-top: 1.5rem;
  display: flex;
  justify-content: center;
  opacity: 0.9;
}

.site-drawer__logo :deep(img) {
  max-width: 5.5rem;
}
</style>

<style>
@import '~@/assets/css/main.css';
@import '~@/assets/css/menu-secundario.css';

/* Shell del drawer PrimeVue — aspecto premium */
.site-drawer-shell.p-sidebar {
  background: var(--drawer-shell-bg) !important;
  border-right: 1px solid rgba(201, 169, 98, 0.2) !important;
  box-shadow: var(--drawer-shell-shadow) !important;
}

.site-drawer-shell .p-sidebar-header {
  background: transparent !important;
  border-bottom: 1px solid rgba(201, 169, 98, 0.12) !important;
  padding: 0.45rem 0.65rem !important;
}

/* PrimeVue usa .p-sidebar-icon { overflow: hidden } — recorta el círculo; forzamos hit area redonda */
.site-drawer-shell .p-sidebar-header .p-sidebar-close.p-link {
  width: var(--nav-icon-touch-min, 2.5rem) !important;
  height: var(--nav-icon-touch-min, 2.5rem) !important;
  min-width: var(--nav-icon-touch-min, 2.5rem) !important;
  min-height: var(--nav-icon-touch-min, 2.5rem) !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 50% !important;
  overflow: visible !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: var(--primary-color, #c9a962) !important;
  background: var(--drawer-close-hit-bg, rgba(255, 255, 255, 0.04)) !important;
  transition: background 0.2s ease, color 0.2s ease;
}

.site-drawer-shell .p-sidebar-header .p-sidebar-close.p-link:hover,
.site-drawer-shell .p-sidebar-header .p-sidebar-close.p-link:focus-visible {
  background: rgba(201, 169, 98, 0.16) !important;
  color: var(--palta-gold-light, #e4d4a4) !important;
  border-radius: 50% !important;
}

.site-drawer-shell .p-sidebar-header .p-sidebar-close-icon,
.site-drawer-shell .p-sidebar-header .p-sidebar-close .p-icon {
  font-size: var(--nav-icon-font-size, 1.125rem) !important;
}

.site-drawer-shell .p-sidebar-content {
  padding: 0 !important;
  background: transparent !important;
}
</style>
